module.exports = __webpack_public_path__ + "img/logo-hbo.e493bb11.svg";